var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 14C14.6667 14.3682 14.3682 14.6667 14 14.6667H0.666667C0.298477 14.6667 0 14.3682 0 14C0 13.6318 0.298477 13.3333 0.666667 13.3333H14C14.3682 13.3333 14.6667 13.6318 14.6667 14Z",
    fill: "#3C5873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20658 11.7921C7.70543 12.2264 6.96125 12.2264 6.4601 11.7921L3.24725 9.00759C2.31452 8.19922 2.88622 6.66667 4.12049 6.66667L5.33334 6.66667V1.33333C5.33334 0.596953 5.93029 1.8094e-07 6.66667 1.16564e-07L8.00001 0C8.73639 -6.43763e-08 9.33334 0.596954 9.33334 1.33333L9.33334 6.66667H10.5462C11.7805 6.66667 12.3522 8.19922 11.4194 9.00759L8.20658 11.7921ZM6.89672 10.4061C7.1473 10.6232 7.51939 10.6232 7.76996 10.4061L10.5462 8H9.00001C8.44772 8 8.00001 7.55228 8.00001 7V1.33333L6.66667 1.33333V7C6.66667 7.55228 6.21896 8 5.66667 8L4.12049 8L6.89672 10.4061Z",
    fill: "#3C5873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b20200e8.svg";
export { ForwardRef as ReactComponent };